import { useApiSegmentThumbnail } from '@app/core/hooks/api/useApiSegmentThumbnail';
import { ThumbnailInfo } from '@app/core/hooks/api/useApiThumbnailsRange';

export type UseThumbnailResult = {
  isLoading: boolean;
  info: ThumbnailInfo | null;
};

/**
 * Fetches thumbnail URL and metadata for a single segment.
 */
export function useThumbnailForSegment(stationId: string, segmentId: number): UseThumbnailResult {
  const thumbnailQuery = useApiSegmentThumbnail(stationId, segmentId, {
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const info = thumbnailQuery.data;
  if (!info) {
    return {
      isLoading: thumbnailQuery.isLoading,
      info: null,
    };
  }

  return {
    isLoading: false,
    info,
  };
}
